/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Actions from './Actions/index'
import React from 'react'
import TaskBoardIcon from 'DesignSystem/TaskBoardIcon/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Home/Content/Tasks/Content/TaskOverview/Content",
  onMouseEnter,
  onMouseLeave,
  isHoveredManual
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  onMouseEnter,
  onMouseLeave,
  isHoveredManual
  
})
let taskBoardMetadataBoardIconIdValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'board.metadata.board_icon_id',
})
let taskPatientNameValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'patient_name',
})
let taskPatientNameValueData1 = fromData.useDataValue({ viewPath,
context: 'task',
path: 'patient_name',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let taskStageNameValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'stage.name',
})
let taskTitleValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'title',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 onMouseOver={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mb-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Actions
  viewPath={`${viewPath}/Actions`}
 is_hovered={isHoveredManual}
/>
</div>
<TaskBoardIcon
  viewPath={`${viewPath}/TaskBoardIcon`}
 width={30}
 height={30}
 data="task.board.metadata.board_icon_id"
 iconId={taskBoardMetadataBoardIconIdValueData}
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--ml-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 data="task.patient_name"
 text={taskPatientNameValueData}
/>
<fromFlow.When is={taskPatientNameValueData1}>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--mr-4-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--ml-3-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-5-Z1Yf8zk': dtColorsNeutral500}}
 className={`views-block ${styles.Vertical1}`}
/>
</fromFlow.When>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 data="task.stage.name"
 color={dtColorsNeutral500}
 text={taskStageNameValueData}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 maxWidth={280}
 display="inline-block"
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 overflowX="hidden"
 size="small"
 color={dtColorsNeutral500}
 data="task.title"
 text={taskTitleValueData}
/>
</div>
</div>
{children}
</React.Fragment>)
}